import React from 'react'
import './RequiredBar.scss'

export const RequiredBar: React.FC<{
  errorsExist?: boolean
  inputEntered?: boolean
  isRequired: boolean
}> = ({ errorsExist, inputEntered, isRequired }) => {
  const htmlClass = 'required-bar'
  const extraClass = errorsExist
    ? `${htmlClass}--error`
    : inputEntered
    ? `${htmlClass}--input-enterred`
    : ''
  if (!isRequired) {
    return null
  }
  return (
    <div className={htmlClass + (extraClass ? ' ' + extraClass : '')}></div>
  )
}
